<div class="card card-custom gutter-b">
  <ng-container *ngIf="requesting">
    <div class="progress progress-modal">
      <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar"
        style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
  </ng-container>

  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">
        <ng-container *ngIf="thismodel">
          {{ (id ? 'COMMON.EDIT' : 'COMMON.NEW') | translate }}
          <span *ngIf="thismodel && thismodel.id">{{ 'COMPANY_CONTACT.COMPANY_CONTACT' | translate }} : {{ thismodel.id }}</span>
        </ng-container>
      </h3>
    </div>
    <div class="card-toolbar">
      <a type="button" class="btn btn-light" routerLink="{{parent}}/contenttypes">
        <i class="fa fa-arrow-left"></i>{{ 'COMMON.BACK' | translate }}
      </a>
      <button class="btn btn-secondary ml-2" (click)="reset()">
        <i class="fa fa-redo"></i>{{ 'COMMON.RESET' | translate }}
      </button>
    </div>
  </div>
  <div class="card-body">
    <ul class="nav nav-tabs nav-tabs-line" role="tablist">
      <li class="nav-item cursor-pointer" (click)="changeTab(tabs.BASIC_TAB)">
        <a class="nav-link" data-toggle="tab" role="tab" [attr.aria-selected]="activeTabId === tabs.BASIC_TAB"
          [class.active]="activeTabId === tabs.BASIC_TAB">
          {{ 'COMMON.BASIC_INFO' | translate }}
        </a>
      </li>
      <!-- <li *ngIf="thismodel && thismodel.id" class="nav-item cursor-pointer" (click)="changeTab(tabs.PROFILE)">
        <a class="nav-link" data-toggle="tab" role="button" [attr.aria-selected]="activeTabId === tabs.PROFILE"
          [class.active]="activeTabId === tabs.PROFILE">Profile</a>
      </li> -->
    </ul>

    <ng-container *ngIf="activeTabId === tabs.BASIC_TAB">
      <div class="mt-5" *ngIf="thismodel">
        <form action="#" class="form form-label-right" [formGroup]="formGroup">
          <div class="form-group row">
            <div class="col-lg-6">
              <label>{{ 'COMMON.ENTER' | translate }} {{ 'CONTENT_TYPE.APP_LABEL' | translate }}</label>
              <input type="text" class="form-control form-control-lg form-control-solid" autocomplete="off"
                name="app_label" [class.is-invalid]="isControlInvalid('app_label')"
                [class.is-valid]="isControlValid('app_label')" formControlName="app_label" />
              <div class="feedback" *ngIf="!isControlTouched('app_label')">{{ 'COMMON.PLEASE_ENTER' | translate }} <b>{{ 'CONTENT_TYPE.APP_LABEL' | translate }}</b></div>
              <div class="valid-feedback" *ngIf="isControlValid('app_label')">{{ 'CONTENT_TYPE.APP_LABEL' | translate }}  {{ 'COMMON.WAS_ENTERED_CORRECT' | translate }}</div>
              <div class="invalid-feedback" *ngIf="controlHasError('required', 'app_label')">{{ 'CONTENT_TYPE.APP_LABEL' | translate }}  {{ 'COMMON.IS_REQUIRED' | translate }}</div>
              <div class="invalid-feedback" *ngIf="controlHasError('minlength', 'app_label')">{{ 'CONTENT_TYPE.APP_LABEL' | translate }} {{ 'COMMON.SHOULD_HAVE_LEAST' | translate }} 3</div>
              <div class="invalid-feedback" *ngIf="controlHasError('maxLength', 'app_label')">{{ 'CONTENT_TYPE.APP_LABEL' | translate }} {{ 'COMMON.SHOULD_HAVE_MAXIMUM' | translate }} 100</div>
            </div>
            <div class="col-lg-6">
              <label>{{ 'COMMON.ENTER' | translate }} {{ 'CONTENT_TYPE.MODEL' | translate }}</label>
              <input type="text" class="form-control form-control-lg form-control-solid" autocomplete="off"
                name="model" [class.is-invalid]="isControlInvalid('model')"
                [class.is-valid]="isControlValid('model')" formControlName="model" />
              <div class="feedback" *ngIf="!isControlTouched('model')">{{ 'COMMON.PLEASE_ENTER' | translate }} <b>{{ 'CONTENT_TYPE.MODEL' | translate }}</b></div>
              <div class="valid-feedback" *ngIf="isControlValid('model')">{{ 'CONTENT_TYPE.MODEL' | translate }}  {{ 'COMMON.WAS_ENTERED_CORRECT' | translate }}</div>
              <div class="invalid-feedback" *ngIf="controlHasError('required', 'model')">{{ 'CONTENT_TYPE.MODEL' | translate }}  {{ 'COMMON.IS_REQUIRED' | translate }}</div>
              <div class="invalid-feedback" *ngIf="controlHasError('minlength', 'model')">{{ 'CONTENT_TYPE.MODEL' | translate }} {{ 'COMMON.SHOULD_HAVE_LEAST' | translate }} 3</div>
              <div class="invalid-feedback" *ngIf="controlHasError('maxLength', 'model')">{{ 'CONTENT_TYPE.MODEL' | translate }} {{ 'COMMON.SHOULD_HAVE_MAXIMUM' | translate }} 100</div>
            </div>
          </div>
          <div class="float-right">
            <a class="btn btn-default font-weight-bold mr-2" routerLink="{{parent}}/contenttypes">{{ 'COMMON.CANCEL' | translate }}</a>
            <button type="submit" class="btn btn-primary font-weight-bold mr-2"
              [disabled]="formGroup.invalid" (click)="save(false)">{{ 'COMMON.SAVE' | translate }}</button>
            <button type="submit" class="btn btn-primary font-weight-bold mr-2"
              [disabled]="formGroup.invalid" (click)="save(true)">{{ 'COMMON.SAVE_AND_EXIT' | translate }}</button>
          </div>
        </form>
      </div>
    </ng-container>
  </div>
</div>